<div class="pr-resumen" *ngIf="proyecto as p">
  <div class="pr-resumen__metricas">
    <section class="ajustes-card" aria-labelledby="pr-resumen-avance">
      <div class="ajustes-card__header">
        <h2 class="ajustes-card__title" id="pr-resumen-avance">
          <span class="material-icons" aria-hidden="true">trending_up</span>Avance
        </h2>
      </div>
      <div class="ajustes-card__body">
        <div class="pr-resumen__datos">
          <span>Días hábiles: <strong>{{ p.uiDiasTotales }}</strong></span>
          <span>Esperado: {{ p.uiDiasAvancePlaneado }} días</span>
          <span>Real: {{ p.uiDiasAvanceReal }} días</span>
        </div>
        <div class="pr-resumen__grafica">
          <canvas #graficaAvance>Avance esperado {{ p.avancePlaneado }} %, real {{ p.avanceReal }} %.</canvas>
        </div>
      </div>
    </section>

    <section class="ajustes-card" aria-labelledby="pr-resumen-esfuerzo">
      <div class="ajustes-card__header">
        <h2 class="ajustes-card__title" id="pr-resumen-esfuerzo">
          <span class="material-icons" aria-hidden="true">schedule</span>Esfuerzo
        </h2>
      </div>
      <div class="ajustes-card__body">
        <div class="pr-resumen__datos">
          <span>Estimado: <strong>{{ p.horasTotales }} hrs.</strong></span>
          <span>Real: {{ p.horasTotalesReales }} hrs.</span>
        </div>
        <div class="pr-resumen__grafica">
          <canvas #graficaEsfuerzo>Esfuerzo estimado {{ p.horasTotales }} horas, real {{ p.horasTotalesReales }} horas.</canvas>
        </div>
      </div>
    </section>

    <section class="ajustes-card" aria-labelledby="pr-resumen-riesgos">
      <div class="ajustes-card__header">
        <h2 class="ajustes-card__title" id="pr-resumen-riesgos">
          <span class="material-icons" aria-hidden="true">warning_amber</span>Riesgos y defectos
        </h2>
      </div>
      <div class="ajustes-card__body">
        <ul class="pr-resumen__riesgos">
          <li *ngFor="let nivel of severidad; index as i">
            <span class="pr-resumen__punto" aria-hidden="true" [style.backgroundColor]="nivel.color"></span>
            {{ p.riesgoCantidad?.[i] ?? 0 }} {{ nivel.descripcion }}
          </li>
        </ul>
        <p class="pr-resumen__defectos">Defectos: <strong>{{ totalDefectos ?? "—" }}</strong></p>
        <div class="pr-resumen__grafica pr-resumen__grafica--riesgo" *ngIf="p.existenRiesgos; else sinRiesgos">
          <canvas #graficaRiesgo>Riesgos por severidad.</canvas>
        </div>
        <ng-template #sinRiesgos>
          <p class="pr-resumen__vacio">
            <span class="material-icons" aria-hidden="true">verified</span>
            Sin riesgos registrados
          </p>
        </ng-template>
      </div>
    </section>
  </div>

  <div class="pr-resumen__textos">
    <section class="ajustes-card" aria-labelledby="pr-resumen-descripcion">
      <div class="ajustes-card__header">
        <h2 class="ajustes-card__title" id="pr-resumen-descripcion">
          <span class="material-icons" aria-hidden="true">description</span>Descripción
        </h2>
      </div>
      <div class="ajustes-card__body">
        <p class="ajustes-card__hint pr-resumen__texto">{{ p.descripcion || "Sin descripción registrada" }}</p>
      </div>
    </section>

    <section class="ajustes-card" aria-labelledby="pr-resumen-seguimiento">
      <div class="ajustes-card__header">
        <h2 class="ajustes-card__title" id="pr-resumen-seguimiento">
          <span class="material-icons" aria-hidden="true">forum</span>Seguimiento reciente
        </h2>
      </div>
      <div class="ajustes-card__body">
        <ng-container *ngIf="p.latestComment?.nombreUsuario; else sinSeguimiento">
          <p class="pr-resumen__meta">{{ p.latestComment.fecha }} · {{ p.latestComment.nombreUsuario }}</p>
          <p class="ajustes-card__hint pr-resumen__texto">{{ p.latestComment.descripcion }}</p>
        </ng-container>
        <ng-template #sinSeguimiento>
          <p class="ajustes-card__hint pr-resumen__texto">No se han registrado actualizaciones</p>
        </ng-template>
      </div>
    </section>
  </div>
</div>
